import { StageDefinition } from './StageDefinition';

export const stage15: StageDefinition = {
    platforms: [
        [0, 0],
        [11.612903225806452, 0],
        [23.225806451612904, 0],
        [34.83870967741936, 0],
        [46.45161290322581, 0],
        [58.064516129032256, 0],
        [69.6774193548387, 0],
        [348.3870967741937, 0],
        [9.473684210526315, 1],
        [18.94736842105263, 1],
        [28.421052631578945, 1],
        [37.89473684210526, 1],
        [47.368421052631575, 1],
        [56.84210526315789, 1],
        [66.3157894736842, 1],
        [350.52631578947336, 1],
        [359.99999999999966, 1],
        [0, 2],
        [8.181818181818182, 2],
        [16.363636363636363, 2],
        [24.545454545454547, 2],
        [32.72727272727273, 2],
        [40.90909090909091, 2],
        [49.090909090909086, 2],
        [57.272727272727266, 2],
        [65.45454545454545, 2],
        [351.818181818182, 2],
        [352.79999999999967, 3],
        [309.4736842105265, 4],
        [315.78947368421075, 4],
        [322.10526315789497, 4],
        [328.4210526315792, 4],
        [334.7368421052634, 4],
        [341.0526315789476, 4],
        [347.36842105263185, 4],
        [353.68421052631606, 4],
        [97.14285714285711, 5],
        [102.85714285714282, 5],
        [108.57142857142853, 5],
        [114.28571428571423, 5],
        [119.99999999999994, 5],
        [125.71428571428565, 5],
        [131.42857142857136, 5],
        [217.1428571428572, 5],
        [222.85714285714292, 5],
        [228.57142857142864, 5],
        [308.5714285714287, 5],
        [314.28571428571445, 5],
        [320.00000000000017, 5],
        [307.82608695652135, 6],
        [313.04347826086916, 6],
        [318.260869565217, 6],
        [307.2000000000004, 7],
        [312.0000000000004, 7],
        [316.8000000000004, 7],
        [307.3170731707312, 8],
        [311.7073170731702, 8],
        [316.0975609756092, 8],
        [4.090909090909091, 9],
        [8.181818181818182, 9],
        [12.272727272727273, 9],
        [16.363636363636363, 9],
        [20.454545454545453, 9],
        [24.545454545454543, 9],
        [28.636363636363633, 9],
        [32.72727272727273, 9],
        [306.81818181818164, 9],
        [310.9090909090907, 9],
        [314.9999999999998, 9],
        [319.09090909090884, 9],
        [323.1818181818179, 9],
        [327.27272727272697, 9],
        [331.36363636363603, 9],
        [335.4545454545451, 9],
        [339.54545454545416, 9],
        [343.6363636363632, 9],
        [347.7272727272723, 9],
        [351.81818181818136, 9],
        [355.9090909090904, 9],
        [359.9999999999995, 9],
    ],
    traps: [
        [220.64516129032265, 0],
        [217.89473684210515, 1],
        [227.36842105263145, 1],
        [220.909090909091, 2],
        [229.09090909090918, 2],
        [64.80000000000001, 3],
        [215.9999999999999, 3],
        [223.19999999999987, 3],
        [230.39999999999986, 3],
        [214.73684210526324, 4],
        [221.05263157894746, 4],
        [227.36842105263167, 4],
        [233.6842105263159, 4],
        [91.4285714285714, 5],
        [137.14285714285708, 5],
        [211.42857142857147, 5],
        [234.28571428571436, 5],
        [325.7142857142859, 5],
        [323.4782608695648, 6],
        [321.6000000000004, 7],
        [320.4878048780482, 8],
    ],
    stars: [
        [139, 10],
        [346, 3],
        [224, 6],
        [337, 6],
        [316, 10],
    ],
};
